import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Globe — language selection. */
export function GlobeIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="12" cy="12" r="8.25" />
      <path d="M3.75 12h16.5" />
      <path d="M12 3.75c-2.5 2.3-3.9 5.1-3.9 8.25s1.4 5.95 3.9 8.25c2.5-2.3 3.9-5.1 3.9-8.25S14.5 6.05 12 3.75Z" />
    </PortalIcon>
  );
}
